import 'angular:locale/data:nl-NL';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "nl-NL";
